import React from 'react';
import isNil from 'lodash/isNil';
import clsx from 'clsx';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import IconButton from '@mui/material/IconButton';
import {
  DEFAULT_REVIEW_OF_SYSTEM_VALUE,
  getDefaultReviewOfSystemRegex,
} from '@populateui/utils';
import Input from 'pages/Dashboard/components/Input';
import ToolTip from 'core/components/Tooltip';
import FieldsArrayWrapper, {
  FieldComponentProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import {
  DeleteIcon,
} from 'core/icons';

type Props = {
  discriminator: string;
};

function Info({
  prefix,
  index,
  onDelete,
}: FieldComponentProps) {
  const { control } = useFormContext();
  const key = `${prefix}.${index}`;
  return (
    <div className="flex flex-row items-center gap-1">
      <Controller
        name={`${key}.title`}
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            error={!isNil(error)}
            showErrorText={false}
            className="space-y-1 flex-1"
            inputClasses={clsx({
              '!bg-[#E9EDF4] rounded': !getDefaultReviewOfSystemRegex(true)
                .test(field.value?.trim()),
            })}
            placeholder="Review"
            id={prefix ?? ''}
          />
        )}
      />
      <ToolTip title="Delete">
        <span>
          <IconButton
            onClick={() => { onDelete(index); }}
            color="error"
          >
            <DeleteIcon className="text-gray-400 !w-5 !h-5" />
          </IconButton>
        </span>
      </ToolTip>
    </div>
  );
}

export default function ReviewInfoContainer({ discriminator }: Props) {
  const prefix = `groupedReviewOfSystemElements.${discriminator}`;

  const getDefaultValue = (
    fields: Record<string, string>[],
    action: 'delete' | 'append',
  ) => {
    const [field] = fields;
    const title = (
      getDefaultReviewOfSystemRegex().test(field?.title)
      || action === 'append'
    ) ? DEFAULT_REVIEW_OF_SYSTEM_VALUE : 'Patient Denies';
    return { discriminator, title };
  };

  return (
    <FieldsArrayWrapper
      keepOne
      title={discriminator}
      append={{}}
      titleClassName="!text-gray-500 !text-xs !mb-1"
      formKey={prefix}
      FieldComponent={Info}
      getDefaultValue={getDefaultValue}
      classes={{
        field: '!mb-2 space-y-0 !w-full !mr-2',
      }}
    />
  );
}
